import { render, staticRenderFns } from "./ProposalRequests.vue?vue&type=template&id=aa315b4e"
import script from "./ProposalRequests.vue?vue&type=script&lang=js"
export * from "./ProposalRequests.vue?vue&type=script&lang=js"
import style0 from "./ProposalRequests.vue?vue&type=style&index=0&id=aa315b4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports